<form (submit)="ingresar(usuario.value, contrasenia.value)">
  <div style="width: 100%; height: 100%;">
    <img src="../../../assets/imagenes/sendEmail1.webp" style="position: fixed; 
    top: 0; 
    left: 0; min-width: 100%;
  min-height: 100%;"/>
    <div style="position: absolute; top: 100px; width: 100%;">
      <table style="width: 100%;">
        <tr>
            <td style="text-align: center;color: #ffffff;"> <!-- #4287f5 -->
              <p style="font-size: 32px; font-weight: bold;">Enviador de mail</p>
            </td>
          </tr>
        <tr>
          <td>
            <div style="width: 100%; text-align: center;">
                <input class="user__input" style="background-color:white;" type="text" #usuario placeholder="Usuario">
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="width: 100%; text-align: center; margin-top: 1vh;">
                <input class="password__input" style="background-color:white;" type="password" #contrasenia placeholder="Contraseña">
            </div>
          </td>
        </tr>
        <tr>
          <td style="width: 30%; text-align: center; padding-top: 1vh;">
            <button mat-raised-button class="btn-agregar" type="submit"
                style="margin-top: 1vh; width: 30%;background-color: #4287f5; cursor: pointer;">
                Ingresar
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
  </form>
